export interface CallTMCount {
    service: number;
    waiting: number;
}
